import React from 'react';
import { paymentMethods } from '../mock';

const PaymentMarquee = () => {
  const loop = [...paymentMethods, ...paymentMethods, ...paymentMethods];
  return (
    <div className="bg-white py-10 overflow-hidden border-y border-[#0f1712]/5">
      <p className="text-center text-xs uppercase tracking-[0.2em] text-[#0f1712]/40 mb-6">Accepts every major card & wallet</p>
      <div className="flex w-max animate-marquee">
        {loop.map((m, i) => (
          <div key={i} className="flex items-center px-9 shrink-0">
            <span className="text-[#0f1712]/35 font-display font-600 text-xl tracking-tight whitespace-nowrap">{m}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentMarquee;
